import { render, staticRenderFns } from "./OrderEvidencePopup.vue?vue&type=template&id=9be19ef4&"
import script from "./OrderEvidencePopup.vue?vue&type=script&lang=js&"
export * from "./OrderEvidencePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports